module.exports = __webpack_public_path__ + "static/media/error.c0df8881.svg";